import { render } from "./PaymentReceipt.vue?vue&type=template&id=6078fee6"
import script from "./PaymentReceipt.vue?vue&type=script&lang=js"
export * from "./PaymentReceipt.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/veins_checkin_vue/veins_checkin_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__